import { StyleSheet } from 'react-native';
import { PALETTE, SIZES } from '../../../../../../../src/constants';

export default StyleSheet.create({
  container: {
    backgroundColor: 'transparent',
    marginHorizontal: SIZES.appHorizontalSpace,
    paddingTop: 14,
    paddingBottom: 12,
    borderBottomWidth: 1,
    borderBottomColor: PALETTE.primaryStrokeLine,
  },
  securityName: {
    paddingBottom: 10,
  },
  row: {
    flexDirection: 'row',
    marginBottom: 5,
  },
  label: {
    color: PALETTE.secondaryDisabled, // TODO ??
  },
});
